import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { ReportsService } from "../services/reports.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { FlatTreeControl } from "@angular/cdk/tree";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
declare var $: any;

interface Report {
  level: number;
  Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  TotalNoOfLoans?: string;
  NoOfLoansOwn?: string;
  NoOfLoansPartner: number;
  TotalPOS_OS?: number;
  POS_OSOwn?: number;
  POS_OSPartner?: number;
  children?: Report[];
}
interface ReportFlatNode {
  expandable: boolean;
    level: number;
   Branch_Name?: string;
  Product_Name?: string;
  LoanIds?: string;
  TotalNoOfLoans?: string;
  NoOfLoansOwn?: string;
  NoOfLoansPartner: number;
  TotalPOS_OS?: number;
  POS_OSOwn?: number;
  POS_OSPartner?: number;
}
@Component({
    selector: "app-own-managed-funds",
    templateUrl: "./own-managed-funds.component.html",
    styleUrls: ["./own-managed-funds.component.scss"],
    standalone: false
})
export class OwnManagedFundsComponent implements OnInit {
  showSpinner: boolean = false;
  private _MasterService;
  ToDate: any = new Date();
  currentUser: any;
  SlabData: any[] = [];
  SlabDropdown: boolean = false;
  ReportType: any = "";
  SlabId: any = "";
  Types: any;
  displayedColumns: string[];
  displayedTreeColumns:string[];

  ExpandBtn: boolean = true;
  CollaspeBtn: boolean = false;
  DataDiv: boolean = false;
  FileCheckingList: any;
  FileCheckingList1: any;
  dataSource: any;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ArrTypes: Array<{ id: number; value: string }> = [
    { id: 1, value: "Branch Wise Portfolio" },
    { id: 2, value: "Product Wise Portfolio" },
    { id: 3, value: "Amount Wise Portfolio" },
    { id: 4, value: "Tenure Wise Portfolio" },
    { id: 5, value: "IRR Wise Portfolio" },
    { id: 6, value: "LTV Wise Portfolio" },
    { id: 7, value: "Gender Wise Portfolio" },
    { id: 8, value: "Religion Wise Portfolio" },
    { id: 9, value: "Caste Wise Portfolio" },
    { id: 10, value: "Marital Status Wise Portfolio" },
    { id: 11, value: "Profile Wise Portfolio" },
    { id: 12, value: "Nature of Work Wise Portfolio" },
  ];

  AcCatgList: any = [];
  LoanAcCategoryId: any = 0;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  public Math = Math;

  constructor(
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService
  ) {
    this._MasterService = MasterService;
  }
   hasChild = (_: number, node: ReportFlatNode) => node.expandable;
       treeControl = new FlatTreeControl<ReportFlatNode>(
          (node) => node.level,
          (node) => node.expandable
        );
        private transformer = (node: Report, level: number) => {
          return {
            expandable: !!node.children && node.children.length > 0,
            Branch_Name:node.Branch_Name,
            Product_Name:node.Product_Name,
            LoanIds:node.LoanIds,
            TotalNoOfLoans:node.TotalNoOfLoans,
            NoOfLoansOwn:node.NoOfLoansOwn,
            NoOfLoansPartner:node.NoOfLoansPartner,
            TotalPOS_OS:node.TotalPOS_OS,
            POS_OSOwn:node.POS_OSOwn,
            POS_OSPartner:node.POS_OSPartner,
            level: level
          };
        };
        treeFlattener = new MatTreeFlattener(
          this.transformer,
          (node) => node.level,
          (node) => node.expandable,
          (node) => node.children
        );
      
        dataSourceTree: any ;

  selectedRow: any;
  
  goToDueListDetails(row: any) {
    // Implement your logic here, e.g., open a modal or navigate to details page
    this.selectedRow = row;
    // Example: $('#ViewDueListDetails').modal('show');
    // Or use Angular Material dialog, or router navigation as per your app
    alert('Show details for: ' + (row.Branch_Name || row.Product_Name));
  }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Own/Managed Funds");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.ArrTypes;
    this.GetAccountingCat();
  }

  getSlabsList(Slab_Type) {
    this._MasterService
      .Get__Slab_dropdown({
        Type: Slab_Type,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((result) => {
        this.SlabData = JSON.parse(JSON.stringify(result));
        console.log("dtaaaa", this.SlabData);
      });
  }

  totaltypewiseBranch1(type: string): number {
  if (this.dataSourceTree && this.dataSourceTree._treeControl) {
    let sum = 0;
    for (let node of this.dataSourceTree._treeControl.dataNodes) {
      if (node.level === 0) {
        sum += Number(node[type]) || 0;
      }
    }
    return sum;
  }
  return 0;
}

  GetAccountingCat() {
    this.lmsService
      .Get_ACC_Category_ForDropdown_By_Type({ Type: "Co-Lending" })
      .subscribe((result) => {
        this.AcCatgList = JSON.parse(JSON.stringify(result));
      });
  }

  onChangeReportTypes() {
    console.log("change Reports Types function call");

    this.SlabDropdown = false;
    this.SlabId = "";
    this.Types = this.ArrTypes.find((obj: any) => {
      return obj.id == this.ReportType;
    }).value;
    switch (this.ReportType) {
      case "3":
        this.SlabDropdown = true;
        this.getSlabsList("Amount");
        break;
      case "4":
        this.SlabDropdown = true;
        this.getSlabsList("Tenure");
        break;
      case "5":
        this.SlabDropdown = true;
        this.getSlabsList("IRR");
        break;
      case "6":
        this.SlabDropdown = true;
        this.getSlabsList("LTV");
        break;
    }
  }

  onSearchOwnManagedFunds() {
    console.log("Search button clicked");
        this.dataSourceTree = null;
          this.DataDiv = false;
    switch (this.ReportType) {
      case "1":
        this.getReportBranchWisePortfolio();
        break;
      case "2":
        this.getReportProductWisePortfolio();
        break;
      case "3":
        this.getReportAmountWisePortfolio();
        break;
      case "4":
        this.getReportTenureWisePortfolio();
        break;
      case "5":
        this.getReportIRRWisePortfolio();
        break;
      case "6":
        this.getReportLTVWisePortfolio();
        break;
      case "7":
        this.getReportGenderWisePortfolio();
        break;
      case "8":
        this.getReportReligionWisePortfolio();
        break;
      case "9":
        this.getReportCasteWisePortfolio();
        break;
      case "10":
        this.getReportMaritalStatusWisePortfolio();
        break;
      case "11":
        this.getReportProfileWisePortfolio();
        break;
      case "12":
        this.getReportNatureOfWorkWisePortfolio();
        break;
    }
  }

  getReportBranchWisePortfolio() {
    this.showSpinner = true;
    this.displayedTreeColumns = [
      //"Id",
      "Branch_Name",
      "Product_Name1",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_BranchWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportProductWisePortfolio() {
    this.showSpinner = true;
    // this.displayedColumns = [
    //   "Id",
    //   "Product_Name",
    //   "TotalNoOfLoans",
    //   "NoOfLoansOwn",
    //   "NoOfLoansPartner",
    //   "TotalPOS_OS",
    //   "POS_OSOwn",
    //   "POS_OSPartner",
    // ];
        this.displayedTreeColumns = [
      //"Id",
      "Product_Name",
      "Branch_Name1",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_ProductWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Product Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTree(res);
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportAmountWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_AmountWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        SlabId: this.SlabId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Account Wise Portfolio", res);
        if (res.length > 0) {
          this.getDataforTable(res, "Amount");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportTenureWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_TenureWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        SlabId: this.SlabId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Tenure Wise Portfolio", res);
        if (res.length > 0) {
          this.getDataforTable(res, "Tenure");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportIRRWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_IRRWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        SlabId: this.SlabId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of IRR Wise Portfolio", res);
        if (res.length > 0) {
          this.getDataforTable(res, "IRR");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportLTVWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "SlabName",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_LTVWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        SlabId: this.SlabId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);
        if (res.length > 0) {
          this.getDataforTable(res, "Branch");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportGenderWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Gender",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_GenderWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "Gender");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportReligionWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Religion",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_ReligionWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "Religion");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportCasteWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Caste",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_CasteWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "Caste");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportMaritalStatusWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "MaritalStatus",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_MaritalStatusWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "MaritalStatus");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportProfileWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Customer_Profile",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_ProfileWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "Customer_Profile");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }

  getReportNatureOfWorkWisePortfolio() {
    this.showSpinner = true;
    this.displayedColumns = [
      "Id",
      "Natureofwork",
      "TotalNoOfLoans",
      "NoOfLoansOwn",
      "NoOfLoansPartner",
      "TotalPOS_OS",
      "POS_OSOwn",
      "POS_OSPartner",
    ];
    this.reportsService
      .Report_OwnPartner_NatureofworkWisePortfolio({
        To: this.ToDate,
        LoginUserId: this.currentUser.userId,
        LoanAcCat: this.LoanAcCategoryId,
      })
      .subscribe((res: any) => {
        console.log("Result of Branch Wise Portfolio", res);

        if (res.length > 0) {
          this.getDataforTable(res, "Natureofwork");
          this.DataDiv = true;
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.DataDiv = false;
        }
        this.showSpinner = false;
      });
  }
  getDataforTree(res) {
    // this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
    // this.dataSource.sort = this.sort;
     if (res.length > 0) {
     this.dataSourceTree = new MatTreeFlatDataSource(
            this.treeControl,
            this.treeFlattener
          );

          var tree = this.unflatten(res);
          console.log("tree",tree);
          this.dataSourceTree.data = tree;
          this.ExpandBtn = true;
          this.CollaspeBtn = false;
          this.showSpinner = false;
         this.showSpinner = false;
     } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          this.showSpinner = false;
          this.dataSourceTree = null;
        }
  }
     OnClickExpandAll() {
    this.ExpandBtn = false;
    this.CollaspeBtn = true;
    this.treeControl.expandAll();
  }
  OnClickCollaspeAll() {
    this.ExpandBtn = true;
    this.CollaspeBtn = false;
    this.treeControl.collapseAll();
  }

  getDataforTable(res, Type) {
    console.log("Type", Type);
    var totalSum = 0;
    res.forEach((x) => {
      totalSum = totalSum + parseFloat(x.POS_OS == null ? 0 : x.POS_OS);
    });
    res.forEach((x) => {
      if (Type == "Branch") {
        x.Name = x.Branch_Name;
      } else if (Type == "Product") {
        x.Name = x.Product_Name;
      } else if (Type == "Gender") {
        x.Name = x.Gender;
      } else if (Type == "Religion") {
        x.Name = x.Religion;
      } else if (Type == "Caste") {
        x.Name = x.Caste;
      } else if (Type == "MaritalStatus") {
        x.Name = x.MaritalStatus;
      } else if (Type == "Customer_Profile") {
        x.Name = x.Customer_Profile;
      } else if (Type == "Natureofwork") {
        x.Name = x.Natureofwork;
      } else {
        x.Name = x.SlabName;
      }
      x.IN_Percentage = (
        (parseFloat(x.POS_OS == null ? 0 : x.POS_OS) / totalSum) *
        100
      ).toFixed(2);
    });
    this.FileCheckingList1 = JSON.parse(JSON.stringify(res));
    console.log("File", this.FileCheckingList1);
    this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));

    this.dataSource.sort = this.sort;

    this.showSpinner = false;
  }
  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem,
      mappedElem;
    let sh;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      
      arrElem = arr[i];
      mappedArr[arrElem.Id] = arrElem;
      mappedArr[arrElem.Id]["children"] = [];
    
  }

    for (var Id in mappedArr) {
      if (mappedArr.hasOwnProperty(Id)) {
        mappedElem = mappedArr[Id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.ParentId>0) {
          mappedArr[mappedElem["ParentId"]]["children"].push(mappedElem);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }

    return tree;
  }

  totaltypewise(type) {
    if (
      this.dataSource != null &&
      this.dataSource != undefined &&
      this.dataSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      switch (type) {
        case "TotalNoOfLoans":
          return sum;
          break;
        case "NoOfLoansOwn":
          return sum;
          break;
        case "NoOfLoansPartner":
          return sum;
          break;
        case "TotalPOS_OS":
          return sum.toFixed(2);
          break;
        case "POS_OSOwn":
          return sum.toFixed(2);
          break;
        case "POS_OSPartner":
          return sum.toFixed(2);
          break;
      }
    }
    return 0;
  }

  exportTable(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "own_managed_funds"
    ) as HTMLTableElement;
    const worksheetName = "OWN/MANAGED FUNDS"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }
}
